import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ApiFilledSvg from "@ant-design/icons-svg/es/asn/ApiFilled";
import AntdIcon from "../components/AntdIcon";
var ApiFilled = function ApiFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ApiFilled.displayName = 'ApiFilled';
}
export default /*#__PURE__*/React.forwardRef(ApiFilled);